export const deviceLinkLocalhostRoot = 'http://localhost:53211/api/v1';

export interface Application {
    id: string;
    name: string;
    version: string;
    isLaunched: boolean;
}

export const ApiApplications = (): Promise<Array<Application>> => {
    return fetch(`${deviceLinkLocalhostRoot}/applications`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
        },
    })
        .then(response => response.json())
}
